import React from "react";
import { Link } from "react-router-dom";

import EyeIcon from "../../../asset/images/home/icon/fi-rr-eye.png";

import S1 from "../../../asset/images/home/modules/1.png";
import S2 from "../../../asset/images/home/modules/2.png";
import S3 from "../../../asset/images/home/modules/3.png";
import S4 from "../../../asset/images/home/modules/4.png";
import S5 from "../../../asset/images/home/modules/5.png";

function CardSee() {
    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 2: Single Letter Sounds (All about the ABCs)
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Virtual Class Demo
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        that you’ve learned how to teach students to learn the sounds of
                        the alphabet, let’s take this further by demonstrating with A.I.
                        students. These are compliant students that will repeat whatever
                        you say. There is an expectation for a correct response from you.
                    </p>
                </div>

                {/* See Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-32 flex items-center justify-center">
                        <img src={EyeIcon} height="20" width="20" className="mr-2" alt="See" />
                        See
                    </button>
                </div>

                {/* Student Images */}
                <div className="flex justify-center gap-2 flex-wrap bg-[#E2F2FF] py-6 rounded-xl mb-8 opacity-40">
                    <img src={S1} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={S2} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={S3} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={S4} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={S5} alt="Student" className="w-50 h-50 object-cover" />
                </div>

                {/* Card Section */}
                <div className="max-w-7xl mx-auto">
                    <div className="bg-white border border-primary rounded-xl py-16 shadow-lg">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                            {/* Left Image */}
                            <div className="flex justify-center">
                                <div className="relative w-40 h-40">
                                    <div className="absolute right-6 w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200 shadow-xl"></div>
                                    <div className="absolute right-3 w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200"></div>

                                    <div className="relative w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200 flex items-center justify-center text-4xl font-bold text-gray-800 shadow-xl">
                                        KK
                                    </div>
                                </div>
                            </div>

                            {/* Right Content */}
                            <div className="p-3 text-center items-center justify-center">
                                <h4 className="text-4xl font-semibold text-gray-700">
                                    Click on the card
                                </h4>
                                <p className="text-gray-500 text-sm mt-3">Let's get ready</p>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Navigation Buttons */}
                <div className="flex justify-end mt-5">
                    <Link to="/dashboard/modules/table">
                        <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8 opacity-50">
                            ← Previous
                        </button>
                    </Link>

                    <Link to="/dashboard/modules/card-hear">
                        <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium opacity-50">
                            Continue Lesson →
                        </button>
                    </Link>
                </div>

            </main>
        </div>
    );
}

export default CardSee;
